import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CeoDto } from 'src/app/data-transfer/entities/doc-entities/ceo-dto';
import { SigneeDto } from 'src/app/data-transfer/entities/doc-entities/signee-dto';

export interface CreateDocSignersDialogData {
  managingDirectors: CeoDto[];
  signers: SigneeDto[];
}

@Component({
  selector: 'app-create-doc-signers-dialog',
  templateUrl: './create-doc-signers-dialog.component.html',
  styleUrls: ['./create-doc-signers-dialog.component.scss'],
})
export class CreateDocSignersDialogComponent {
  readonly managingDirectors: CeoDto[];
  readonly signers: SigneeDto[];

  form: FormGroup<{
    managingDirectorId: FormControl<number | null>;
    signerId: FormControl<number | null>;
    hasOtherSigner: FormControl<boolean>;
  }>;

  constructor(
    private dialogRef: MatDialogRef<CreateDocSignersDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: CreateDocSignersDialogData
  ) {
    this.managingDirectors = data.managingDirectors;
    this.signers = data.signers;
    this.form = this.fb.group({
      managingDirectorId: new FormControl<number | null>(data.managingDirectors[0]?.personProfileId ?? null),
      signerId: new FormControl<number | null>(data.signers[0]?.personProfileId ?? null),
      hasOtherSigner: new FormControl<boolean>(false, { nonNullable: true }),
    });
  }

  get selectedManagingDirector(): CeoDto | undefined {
    return this.managingDirectors.find(p => p.personProfileId === this.form.value.managingDirectorId);
  }

  get selectedSigner(): SigneeDto | undefined {
    return this.signers.find(p => p.personProfileId === this.form.value.signerId);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onContinue(): void {
    const value = this.form.value;
    this.dialogRef.close({
      confirmed: true,
      ceoId: value.managingDirectorId,
      signeeId: value.hasOtherSigner ? value.signerId : null,
    });
  }
}
